import { render } from "./fileList.vue?vue&type=template&id=229b4f8a&scoped=true"
import script from "./fileList.vue?vue&type=script&lang=js"
export * from "./fileList.vue?vue&type=script&lang=js"

import "./fileList.vue?vue&type=style&index=0&id=229b4f8a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229b4f8a"]])

export default __exports__